export default __webpack_public_path__ + "static/Phoenix-930cb8a5d77fc4305acbddf3ff673b57.png";